import { sitPlatformHeaderName } from './headers.js';
export const CompanyIdHeader = 'X-SIT-Company-Id';
/** Used by the backend only, Intacct uses this header to sign messages to SIT */
export const IntacctSignatureHeader = 'x-intacct-signature';
export const PreviousIntacctAccessTokenHeader = 'x-previous-intacct-access-token';
export const MobileAppVersionHeader = 'x-app-version';
export const MobileDeviceOSHeader = 'x-device-os';
//# sourceMappingURL=requests.js.map